/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Test_Internet_Gateway_RequiredInputs */



/**
* | output |
* | --- |
* | "An internet-connected box is required" |
*
* @param {Mesh_Test_Internet_Gateway_RequiredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_test_internet_gateway_required = /** @type {((inputs?: Mesh_Test_Internet_Gateway_RequiredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Test_Internet_Gateway_RequiredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("An internet-connected box is required")
	return /** @type {LocalizedString} */ ("Une box connectée à Internet est requise")
});